import { render, staticRenderFns } from "./TraspasosMovimientosForm.vue?vue&type=template&id=6da225a1&"
import script from "./TraspasosMovimientosForm.vue?vue&type=script&lang=js&"
export * from "./TraspasosMovimientosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports